import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesTerritory = {
  state: '',
  code: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageTerritoryListInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesTerritory}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageTerritoryListInitializer.displayName = 'Page Territory List initializer component';

export default PageTerritoryListInitializer;
